import {
	GIC_VIEW_TYPE,
	ISSUE_VIEW_VIEW_TYPE,
	ISSUE_TRANSITION_VIEW_TYPE,
} from '@atlassian/jira-ui-modifications-constants';
import type { ViewType } from '@atlassian/jira-ui-modifications-types';
import type { ViewConfiguration } from '../common/types';
import { GICViewConfiguration } from './gic';
import { IssueTransitionViewConfiguration } from './issue-transition';
import { IssueViewViewConfiguration } from './issue-view';

export const supportedViews: Record<ViewType, ViewConfiguration> = {
	[GIC_VIEW_TYPE]: new GICViewConfiguration(),
	[ISSUE_VIEW_VIEW_TYPE]: new IssueViewViewConfiguration(),
	[ISSUE_TRANSITION_VIEW_TYPE]: new IssueTransitionViewConfiguration(),
};
